import "./App.css"
import { BrowserRouter, Switch, Route } from "react-router-dom"
import Nav from "./components/Nav"
import About from "./components/About"
import NavB from "./components/NavB"
import Main from "./components/Main"
import { useEffect, useState } from "react"
import Blog from "./components/Blog"

function App() {
	// useEffect(() => {
	// 	if (document.visibilityState == "visible") {
	// 		console.log("first time visit")

	// 		document.addEventListener("visibilitychange", () => {
	// 			if (document.hidden) {
	// 				console.log("user gone")
	// 				localStorage.setItem("user", null)
	// 			} else {
	// 				console.log("user revisited")
	// 				localStorage.setItem("user", JSON.stringify("a"))
	// 			}
	// 		})
	// 	}
	// }, [])

	return (
		<BrowserRouter>
			<Nav
				styles={
					window.location.pathname == "/blog/:id" ? { display: "none" } : {}
				}
			/>
			<Switch>
				<Route exact path="/">
					<About />
					<Main />
				</Route>

				<Route path="/main">
					<Main />
				</Route>

				<Route exact path="/blog">
					<Blog />
				</Route>
				<Route path="/blog/:id">
					<Blog />
				</Route>
			</Switch>
			<NavB
				styles={
					window.location.pathname == "/blog/:id" ? { display: "none" } : {}
				}
			/>
		</BrowserRouter>
	)
}

export default App
